module.exports = __webpack_public_path__ + "resources/img/img_private_region_gov_m.d85790954f7409dad554552b381caace.png";